export const INITIAL_STATE = {
  timestamp: undefined,
};

export const SET_CURSOR = "appoptics/infrastructure/hostViewCursor/SET_CURSOR";

export const setCursor = timestamp => ({
  type: SET_CURSOR,
  timestamp,
});

const hostViewCursorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CURSOR:
      return {
        timestamp: action.timestamp,
      };
    default:
      return state;
  }
};

export default hostViewCursorReducer;
